import React from 'react';
import ReactPaginate from "react-paginate";

const Pagination = ({pageCount, params, loading, handlePageClick}) => {
    return (
        pageCount > 1 &&
        <ReactPaginate
            previousLabel={<i className="fas fa-chevron-left"/>}
            nextLabel={<i className="fas fa-chevron-right"/>}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            initialPage={params.get('page') ? params.get('page') - 1 : 0}
            disableInitialCallback={true}
            onPageChange={handlePageClick}
            containerClassName={`paginations ${loading ? 'isLoading' : ''}`}
            activeClassName={'active'}
            forcePage={params.get('page') ? params.get('page') - 1 : 0}
        />
    );
};

export default Pagination;